<template>
    <ForecastingManagement
        :routePlantId="plantId"
        :routeProductCategoryId="productCategoryId"
        :routeCropLocationId="cropLocationId"
        :routeVarietyId="varietyId"
        :routeForecastMode="forecastMode">
    </ForecastingManagement>
</template>

<script>
import ForecastingManagement from '@/components/forecasting/ForecastingManagement.vue'

export default {
    components: {
        ForecastingManagement
    },
    data(){
        return {

        };
    },
    computed: {
        plantId() { 
            let val = this.$route.query.plantId;

            if(val) {
                return parseInt(val);
            }
            
            return null;
        },
        productCategoryId() {
            let val = this.$route.query.productCategoryId;

            if(val) {
                return parseInt(val);
            }
            
            return null;
        },
        cropLocationId() {
            let val = this.$route.query.cropLocationId;
            if(val) {
                return parseInt(val);
            }  
            return null;
        },
        varietyId() {
            let val = this.$route.query.varietyId;
            if(val) {
                return parseInt(val);
            }  
            return null;
        },
        forecastMode() {
            let val = this.$route.query.forecastMode;
            if(val) {
               return parseInt(val);
            }  
            return null;
        }
    },
    methods: {

    },
    created(){
        
    }
}
</script>